import moment from "moment";
import { i18n } from "../app/pages/private/languageSelector";
import ct from "countries-and-timezones/dist/index.js";

export const getNumber = (num) => {
  let str = "" + num;
  let pad = "00000";
  let ans = pad.substring(0, pad.length - str.length) + str;
  return ans;
};

export const transformColumnName = (name) => {
  if (name === "grossSales") {
    return i18n("DASHBOARD.GrossSales");
  } else if (name === "refunds") {
    return i18n("INVOICES.Refunds");
  } else if (name === "netSales") {
    return i18n("DASHBOARD.NetSales");
  } else if (name === "discountTotal" || name === "discounts") {
    return i18n("LandingPage.Discounts");
  } else if (name === "tax") {
    return i18n("DASHBOARD.Taxes");
  } else if (name === "costOfGoods") {
    return i18n("DASHBOARD.Cost");
  } else if (name === "grossProfit") {
    return i18n("DASHBOARD.GrossProfit");
  } else if (name === "margin") {
    return i18n("DASHBOARD.Margin");
  } else if (name === "date") {
    return i18n("Form.Date");
  } else if (name === "hour") {
    return i18n("DASHBOARD.Hour");
  } else if (name === "productsSold") {
    return i18n("DASHBOARD.ProductSold");
  } else if (name === "sku") {
    return i18n("DASHBOARD.SKU");
  } else if (name === "productsRefunded") {
    return i18n("DASHBOARD.ProductRefunded");
  } else if (name === "categoryName") {
    return i18n("DASHBOARD.Category");
  } else if (name === "productName") {
    return i18n("DASHBOARD.Product");
  } else if (name === "userName") {
    return i18n("DASHBOARD.UserName");
  } else if (name === "saleInvoices") {
    return i18n("DASHBOARD.SaleInvoices");
  } else if (name === "refundInvoices") {
    return i18n("DASHBOARD.RefundInvoices");
  } else if (name === "netSalesAverage") {
    return i18n("DASHBOARD.NetSalesAverage");
  } else if (name === "customersSignedUp") {
    return i18n("DASHBOARD.CustomersSignedUp");
  } else if (name === "paymentChannel") {
    return i18n("DASHBOARD.PaymentChannel");
  } else if (name === "paymentTransactions") {
    return i18n("DASHBOARD.PaymentTransactions");
  } else if (name === "paymentAmount") {
    return i18n("DASHBOARD.PaymentAmount");
  } else if (name === "refundTransactions") {
    return i18n("DASHBOARD.RefundTransactions");
  } else if (name === "refundedAmount") {
    return i18n("DASHBOARD.RefundedAmount");
  } else if (name === "netAmount") {
    return i18n("DASHBOARD.NetAmount");
  } else if (name === "discountName") {
    return i18n("DASHBOARD.DiscountName");
  } else if (name === "discountRate") {
    return i18n("DASHBOARD.DiscountRate");
  } else if (name === "discountsApplied") {
    return i18n("DASHBOARD.DiscountsApplied");
  } else if (name === "amountDiscounted") {
    return i18n("DASHBOARD.AmountDiscounted");
  } else if (name === "taxName") {
    return i18n("DASHBOARD.TaxName");
  } else if (name === "taxRate") {
    return i18n("DASHBOARD.TaxRate");
  } else if (name === "taxableSales") {
    return i18n("DASHBOARD.TaxableSales");
  } else if (name === "taxAmount") {
    return i18n("DASHBOARD.TaxAmount");
  } else if (name === "time") {
    return i18n("DASHBOARD.Time");
  } else if (name === "grossSalesAvg") {
    return i18n("DASHBOARD.GrossSalesAvg");
  } else if (name === "refundsAvg") {
    return i18n("DASHBOARD.RefundsAvg");
  } else if (name === "discountsAvg") {
    return i18n("DASHBOARD.DiscountsAvg");
  } else if (name === "netSalesAvg") {
    return i18n("DASHBOARD.NetSalesAvg");
  } else return name;
  // return name
  //   .replace(/([A-Z])/g, " $1")
  //   .replace(/^./, (str) => str.toUpperCase())
  //   .trim();
};

export const formatValue = (value) => {
  if (typeof value !== "number") return value; // Return as is if not a number
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const generateHourLabels = () => {
  return Array.from({ length: 24 }, (_, i) => {
    const hour = i.toString().padStart(2, "0");
    return `${hour}:00`;
  });
};

export const renderCellValue = (value) => {
  if (value === undefined || value === null) {
    return ""; // Handle undefined or null values
  }
  if (typeof value === "object") {
    if (value.first && value.last) {
      // Handle objects with 'first' and 'last' properties
      return `${value.first} ${value.last}`;
    }
    // Handle other objects (e.g., convert to string)
    return Object.keys(value)
      .map((key) => `${key}: ${value[key]}`)
      .join(", ");
  }
  return value;
};

export function numberWithCommas(x) {
  if (x === null || x === undefined) {
    return "";
  }
  return x.toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatNumber(value) {
  // Check if the value is a number
  if (typeof value === "number" && !isNaN(value)) {
    // Format the number to two decimal places and add commas
    return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else if (value instanceof Date) {
    // Format the date as desired
    return value.toLocaleDateString("en-US"); // Example format, adjust as needed
  } else {
    // Handle other cases (e.g., return a placeholder or the original value)
    return value;
  }
}

export const getSkuNumber = (product) => {
  let value;
  product.sort((a, b) => {
    return a.sku - b.sku;
  });
  if (product?.length === 0) {
    value = (0 + 1).toString().padStart(4, "0");
  } else {
    for (let i = 1; i <= product.length; i++) {
      if (product[i - 1].sku !== i) {
        value = i.toString().padStart(4, "0");
        break;
      } else {
        value = (i + 1).toString().padStart(4, "0");
      }
    }
  }
  return value;
};

export function incrementCharacter(string) {
  function getValue(s) {
    return s?.split("").reduce((r, a) => r * 26 + parseInt(a, 36) - 9, 0) - 1;
  }
  function setValue(n) {
    var result = "";
    do {
      result = ((n % 26) + 10).toString(36) + result;
      n = Math.floor(n / 26) - 1;
    } while (n >= 0);
    return result.toUpperCase();
  }

  return setValue(getValue(string) + 1);
}

export const refactorTimeRangeLabel = (label) => {
  if (label === "hourly") {
    return i18n("LandingPage.Hourly");
  } else if (label === "yearly") {
    return i18n("LandingPage.Yearly");
  } else if (label === "quarterly") {
    return i18n("LandingPage.Quarterly");
  } else if (label === "monthly") {
    return i18n("LandingPage.Monthly");
  } else if (label === "daily") {
    return i18n("LandingPage.Daily");
  } else if (label === "weekly") {
    return i18n("LandingPage.Weekly");
  }
};

export const translateModuleName = (name) => {
  if (name === "Sales by Summary") {
    return i18n("LandingPage.SalesSummary");
  } else if (name === "Sales by Product") {
    return i18n("LandingPage.SalesByProduct");
  } else if (name === "Sales by Category") {
    return i18n("LandingPage.SalesByCategory");
  } else if (name === "Sales by User") {
    return i18n("LandingPage.SalesByUser");
  } else if (name === "Sales by Payment Channel") {
    return i18n("LandingPage.SalesByPaymentChanel");
  } else if (name === "Sales by Time") {
    return i18n("LandingPage.SalesByTime");
  } else if (name === "Taxes") {
    return i18n("LandingPage.Taxes");
  } else if (name === "Discounts") {
    return i18n("LandingPage.Discounts");
  } else if (name === "Categories") {
    return i18n("global.Categories");
  } else if (name === "Products") {
    return i18n("Company.Products");
  } else if (name === "Customers") {
    return i18n("Company.Customers");
  } else if (name === "Payment Channels") {
    return i18n("global.PaymentChannels");
  } else if (name === "Stores") {
    return i18n("Company.Stores");
  } else if (name === "Pos Devices") {
    return i18n("Company.PosDevice");
  } else if (name === "Users") {
    return i18n("Company.Users");
  } else if (name === "Roles") {
    return i18n("Company.Roles");
  } else if (name === "Invoices") {
    return i18n("DASHBOARD.Invoices");
  } else if (name === "User Settings") {
    return i18n("UserProfile.AccountSettings");
  } else if (name === "Subscription") {
    return i18n("Company.Subscription");
  } else if (name === "Zatca") {
    return i18n("Integration.ZATCA");
  } else {
    return i18n("Integration.ZatcaIntegration");
  }
};
export const translateDate = (startDate, language) => {
  let date = moment(startDate).format("MMM/D/YYYY");
  if (moment(date).isValid() && language === "arabic") {
    let firstItem = date?.split("/")[0];
    let month;
    if (firstItem === "Sep") {
      month = i18n("Form.Sep");
    } else if (firstItem === "Oct") {
      month = i18n("Form.Oct");
    } else if (firstItem === "Nov") {
      month = i18n("Form.Nov");
    } else if (firstItem === "Dec") {
      month = i18n("Form.Dec");
    } else if (firstItem === "Jan") {
      month = i18n("Form.Jan");
    } else if (firstItem === "Feb") {
      month = i18n("Form.Feb");
    } else if (firstItem === "Mar") {
      month = i18n("Form.Mar");
    } else if (firstItem === "Apr") {
      month = i18n("Form.Apr");
    } else if (firstItem === "May") {
      month = i18n("Form.May");
    } else if (firstItem === "Jun") {
      month = i18n("Form.Jun");
    } else if (firstItem === "Jul") {
      month = i18n("Form.Jul");
    } else if (firstItem === "Aug") {
      month = i18n("Form.Aug");
    }
    return moment(startDate).format(`${month} D, YYYY`);
  }
  return moment(startDate).format("MMM D, YYYY");
};

export const translateHeaderLabel = (headerLabel) => {
  if (headerLabel === "Today" || headerLabel === "اليوم") {
    headerLabel = i18n("DASHBOARD.Today");
  } else if (headerLabel === "Yesterday" || headerLabel === "أمس") {
    headerLabel = i18n("DASHBOARD.Yesterday");
  } else if (headerLabel === "This Week" || headerLabel === "هذا الأسبوع") {
    headerLabel = i18n("DASHBOARD.ThisWeek");
  } else if (headerLabel === "This Month" || headerLabel === "هذا الشهر") {
    headerLabel = i18n("DASHBOARD.ThisMonth");
  } else if (headerLabel === "Last Month" || headerLabel === "آخر شهر") {
    headerLabel = i18n("DASHBOARD.LastMonth");
  } else if (headerLabel === "Last Week" || headerLabel === "آخر أسبوع") {
    headerLabel = i18n("DASHBOARD.LastWeek");
  } else if (headerLabel === "Last 7 Days" || headerLabel === "اخر 7 ايام") {
    headerLabel = i18n("DASHBOARD.Last7Days");
  } else if (headerLabel === "Last 30 Days" || headerLabel === "آخر 30 يومًا") {
    headerLabel = i18n("DASHBOARD.Last30Days");
  } else if (headerLabel === "Custom Range" || headerLabel === "نطاق مخصص") {
    headerLabel = i18n("DASHBOARD.CustomRange");
  }
  return headerLabel;
};

export const translateMonthsFromCharts = (item) => {
  if (!item?.includes(":00")) {
    let month = item?.slice(item?.length - 3, item?.length);
    let date = item?.slice(0, item?.indexOf(month));

    if (month === "Jan") {
      return i18n("DASHBOARD.Jan") + date;
    } else if (month === "Feb") {
      return i18n("DASHBOARD.Feb") + date;
    } else if (month === "Mar") {
      return i18n("DASHBOARD.Mar") + date;
    } else if (month === "Apr") {
      return i18n("DASHBOARD.Apr") + date;
    } else if (month === "May") {
      return i18n("DASHBOARD.May") + date;
    } else if (month === "Jun") {
      return i18n("DASHBOARD.Jun") + date;
    } else if (month === "Jul") {
      return i18n("DASHBOARD.Jul") + date;
    } else if (month === "Aug") {
      return i18n("DASHBOARD.Aug") + date;
    } else if (month === "Sep") {
      return i18n("DASHBOARD.Sep") + date;
    } else if (month === "Oct") {
      return i18n("DASHBOARD.Oct") + date;
    } else if (month === "Nov") {
      return i18n("DASHBOARD.Nov") + date;
    } else if (month === "Dec") {
      return i18n("DASHBOARD.Dec") + date;
    } else return month + date;
  } else {
    return item;
  }
};

export function getModalWidth() {
  if (window.innerWidth > 450) {
    return "400px"; // Fixed width for larger devices
  } else {
    return "calc(100% - 30px)"; // Dynamic width for smaller devices
  }
}

export const refactorValues = (values, language, currency) => {
  let refactoredValues = {};
  if (language === "en") {
    refactoredValues["total"] = currency ? `${currency} 00.00` : "SAR 00.00";
    refactoredValues["totalText"] = "Total";
    refactoredValues["totalTextSec"] = "Total";
    refactoredValues["invoiceNo"] = "invoice No.";
    refactoredValues["date"] = "Date:";
    refactoredValues["cashier"] = "Cashier:";
    refactoredValues["pos"] = "POS:";
    refactoredValues["taxNo"] = "Tax No.";
    refactoredValues["simplifiedInvoice"] = "Simplified tax invoice";
    refactoredValues["cash"] = "Cash";
    refactoredValues["change"] = "Change";
    refactoredValues["customer"] = "Customer:";
    refactoredValues["mobile"] = "Mobile";
    refactoredValues["creditNote"] = "Credit Note";
    refactoredValues["refund"] = "Refund";
    refactoredValues["subTotal"] = "Sub Total";
    refactoredValues["totalBeforeTax"] = "Total Before Tax";
    refactoredValues["totalWithTax"] = "Total With Tax";
    refactoredValues["totalAfterTax"] = "Total After Tax";
    refactoredValues["amountDue"] = "Amount Due";
    refactoredValues["included"] = "Included";
    refactoredValues["notesAppearHere"] = "Note will appear here";
    refactoredValues["parentInvoice"] = "Parent Invoice:";
    refactoredValues["creditNoteInvoice"] = "Credit Note";
    refactoredValues["discountByPoints"] = "Discount by Points";
  } else {
    refactoredValues["total"] = "00.00 ر.س ";
    refactoredValues["totalText"] = " الإجمالي ";
    refactoredValues["totalTextSec"] = " المجموع ";
    refactoredValues["invoiceNo"] = ":رقم الفاتورة";
    refactoredValues["date"] = ":تاريخ";
    refactoredValues["cashier"] = ":الكاشير";
    refactoredValues["pos"] = ":نقطة البيع";
    refactoredValues["taxNo"] = "الرقم الضريبي ";
    refactoredValues["simplifiedInvoice"] = " فاتورة ضريبية مبسطة";
    refactoredValues["cash"] = "نقداً";
    refactoredValues["change"] = "المتبقي";
    refactoredValues["customer"] = ":العميل";
    refactoredValues["mobile"] = "الجوال";
    refactoredValues["creditNote"] = "مذكرة الائتمان";
    refactoredValues["refund"] = "إسترداد";
    refactoredValues["subTotal"] = "الإجمالي الفرعي";
    refactoredValues["totalBeforeTax"] = "الإجمالي قبل الضريبة";
    refactoredValues["totalWithTax"] = "الإجمالي مع الضريبة";
    refactoredValues["amountDue"] = "المبلغ المستحق";
    refactoredValues["included"] = "متضمنة";
    refactoredValues["notesAppearHere"] = " سوف تظهر ملاحظة هنا";
    refactoredValues["parentInvoice"] = ":الفاتورة الأصلية";
    refactoredValues["totalAfterTax"] = "المجموع بعد الضريبة";
    refactoredValues["creditNoteInvoice"] = "اشعار دائن";
    refactoredValues["discountByPoints"] = "الخصم بالنقاط";
  }
  return refactoredValues;
};

export const translateInvoicePdfData = (language) => {
  let translatedData = {};
  if (language === "en") {
    translatedData["customerInformation"] = "Customer Information";
    translatedData["invoiceInformation"] = "Invoice Information";
    translatedData["taxInvoice"] = "Tax Invoice";
    translatedData["customerName"] = "Customer Name:";
    translatedData["businessName"] = "Business Name:";
    translatedData["email"] = "Email:";
    translatedData["mobile"] = "Mobile:";
    translatedData["taxId"] = "Tax ID:";
    translatedData["number"] = "Invoice Number:";
    translatedData["date"] = "Date:";
    translatedData["status"] = "Status:";
    translatedData["type"] = "Type:";
    translatedData["itemName"] = "Item Name";
    translatedData["description"] = "Description";
    translatedData["unitPrice"] = "Unit Price";
    translatedData["units"] = "Units";
    translatedData["disc"] = "Disc.";
    translatedData["totalBeforeTax"] = "Total Before TAX";
    translatedData["vat"] = "VAT";
    translatedData["inclusive"] = "Inclusive";
    translatedData["totalWithTax"] = "Total With TAX";
    translatedData["payments"] = "Payments";
    translatedData["paid"] = "Paid";
    translatedData["balanceDue"] = "Balance due";
    translatedData["dueDate"] = "Due Date";
    translatedData["cash"] = "Cash";
    translatedData["total"] = "Total";
    translatedData["totalText"] = "Total";
    translatedData["subTotal"] = "Sub Total";
    translatedData["sar"] = "SAR";
    translatedData["replacementPolicy"] = "Replacement Policy:";
    translatedData["note"] = "Note";
    translatedData["termsAndCond"] = "Terms and Conditions:";
    translatedData["poweredBy"] = "Powered By";
    translatedData["printed"] = "Printed";
    translatedData["replacememtPolicyDesc"] = "To view the replacement policy, please visit the following link";
    translatedData["termsAndCondDesc"] = "To view the Terms and Conditions, please visit the following link";
    translatedData["creditNote"] = "Credit Note";
    translatedData["refund"] = "Refund";
    translatedData["PAID"] = "PAID";
    translatedData["sales"] = "Sales";
    translatedData["invoice"] = "Invoice";
    translatedData["parentInvoiceNo"] = "Parent Invoice Number:";
    translatedData["simplifiedTaxInvoice"] = "Simplified tax invoice";
    translatedData["creditNoteInvoice"] = "Credit Note";
  } else {
    translatedData["customerInformation"] = "معلومات العميل";
    translatedData["invoiceInformation"] = "معلومات الفاتورة";
    translatedData["taxInvoice"] = "فاتورة ضريبية";
    translatedData["customerName"] = ": اسم العميل";
    translatedData["businessName"] = ": اسم العمل";
    translatedData["email"] = ": البريد الإلكتروني";
    translatedData["mobile"] = ": الجوال";
    translatedData["taxId"] = ": الرقم الضريبي";
    translatedData["number"] = ": رقم الفاتورة";
    translatedData["date"] = ": التاريخ";
    translatedData["status"] = ": الحالة";
    translatedData["type"] = ": النوع";
    translatedData["itemName"] = "اسم المنتج";
    translatedData["description"] = "الوصف";
    translatedData["unitPrice"] = "سعر الوحدة";
    translatedData["units"] = "وحدة";
    translatedData["disc"] = "خصم";
    translatedData["totalBeforeTax"] = "مجموع قبل الضريبة";
    translatedData["vat"] = "VAT";
    translatedData["inclusive"] = "شاملة";
    translatedData["totalWithTax"] = "مجموع مع الضرائب";
    translatedData["payments"] = "المدفوعات";
    translatedData["paid"] = "مدفوع";
    translatedData["balanceDue"] = "الرصيد المستحق";
    translatedData["dueDate"] = "تاريخ الاستحقاق";
    translatedData["cash"] = "نقداً";
    translatedData["total"] = "المجموع";
    translatedData["totalText"] = "الإجمالي";
    translatedData["subTotal"] = "الإجمالي الفرعي";
    translatedData["sar"] = "ر.س";
    translatedData["replacementPolicy"] = "سياسة الاستبدال:";
    translatedData["note"] = "ملاحظة";
    translatedData["termsAndCond"] = "الشروط والأحكام:";
    translatedData["poweredBy"] = "مدعوم من";
    translatedData["printed"] = "مطبوعة";
    translatedData["replacememtPolicyDesc"] = "لعرض سياسة الاستبدال ، يرجى زيارة الرابط التالي";
    translatedData["termsAndCondDesc"] = "لعرض الشروط والأحكام ، يرجى زيارة الرابط التالي";
    translatedData["creditNote"] = "إشعار مدين";
    translatedData["refund"] = "إسترداد";
    translatedData["PAID"] = "مدفوعة";
    translatedData["sales"] = "بيع";
    translatedData["invoice"] = "فاتورة";
    translatedData["parentInvoiceNo"] = "رقم الفاتورة الاصلية:";
    translatedData["simplifiedTaxInvoice"] = "فاتورة ضريبية مبسطة";
    translatedData["creditNoteInvoice"] = "اشعار دائن";
  }
  return translatedData;
};

export const translateRolePayload = () => {
  let translatedData = {};
  translatedData["accessDashboard"] = "الوصول إلى التقارير";
  translatedData["accessCustomers"] = "الوصول إلى العملاء";
  translatedData["accessInvoices"] = "الوصول إلى الفواتير";
  translatedData["accessMenu"] = "الوصول إلى العناصر";
  translatedData["accessCompanyProfile"] = "الوصول لإعدادات الشركة";
  translatedData["createData"] = "إنشاء بيانات";
  translatedData["editData"] = "تحرير بيانات";
  translatedData["deleteData"] = "حذف بيانات";
  translatedData["accessToLiveChat"] = "الوصول إلى محادثات الدعم المباشرة";
  translatedData["createNewProductsInSale"] = "إنشاء منتج أثناء البيع";
  translatedData["applyDiscountWithRestrictedAccess"] = "تطبيق الخصومات ذات الوصول المقيد";
  translatedData["products"] = "المنتجات";
  translatedData["categories"] = "الفئات";
  translatedData["discounts"] = "الخصومات";
  translatedData["companyProfile"] = "الوصول لإعدادات الشركة";
  translatedData["companyInformation"] = "معلومات الشركة";
  translatedData["roles"] = "الأدوار";
  translatedData["users"] = "المستخدمين";
  translatedData["pos"] = "نقاط البيع";
  translatedData["taxes"] = "الضرائب";
  translatedData["stores"] = "المتاجر";
  translatedData["paymentChannels"] = "قنوات الدفع";
  translatedData["subscription"] = "الاشتراكات";
  translatedData["logBook"] = "السجل";
  translatedData["viewInvoices"] = "عرض الفواتير";
  translatedData["onlyLast5"] = "آخر 5 فواتير فقط";
  translatedData["allInvoices"] = "جميع الفواتير";
  translatedData["changeTaxesInSale"] = "تغيير الضرائب أثناء البيع";
  translatedData["showQuickProductInPos"] = "الوصول إلى المنتج السريع في نقاط البيع";
  translatedData["performRefunds"] = "إجراء عمليات الاسترداد";
  translatedData["reprintAndResendInvoices"] = "إعادة طباعة وإعادة إرسال الفواتير";
  translatedData["manageMenu"] = "إدارة العناصر";
  translatedData["changeSettings"] = "إدارة الإعدادات";
  translatedData["managePosLoginViaEmailLogin"] = "ادارة اجهزة نقاط البيع عبر الدخول بالايميل";
  return translatedData;
};

export const translateRoleName = (name) => {
  let translatedData = translateRolePayload();
  if (name?.includes("Access to reports")) {
    return translatedData.accessDashboard;
  } else if (name?.includes("Access to customers")) {
    return translatedData.accessCustomers;
  } else if (name?.includes("Access to invoices")) {
    return translatedData.accessInvoices;
  } else if (name?.includes("Access to items")) {
    return translatedData.accessMenu;
  } else if (name?.includes("Company Profile")) {
    return translatedData.accessCompanyProfile;
  } else if (name?.includes("Create Data")) {
    return translatedData.createData;
  } else if (name?.includes("Edit")) {
    return translatedData.editData;
  } else if (name?.includes("Delete")) {
    return translatedData.deleteData;
  } else if (name?.includes("live chat")) {
    return translatedData.accessToLiveChat;
  } else if (name?.includes("Create New Products in a Sale")) {
    return translatedData.createNewProductsInSale;
  } else if (name?.toLowerCase().includes("apply discounts with restricted access")) {
    return translatedData.applyDiscountWithRestrictedAccess;
  } else if (name === "Products") {
    return translatedData.products;
  } else if (name === "Categories") {
    return translatedData.categories;
  } else if (name === "Discounts") {
    return translatedData.discounts;
  } else if (name === "Access to company settings") {
    return translatedData.accessCompanyProfile;
  } else if (name === "Company Information") {
    return translatedData.companyInformation;
  } else if (name === "Roles") {
    return translatedData.roles;
  } else if (name === "Stores") {
    return translatedData.stores;
  } else if (name === "Taxes") {
    return translatedData.taxes;
  } else if (name === "POSs") {
    return translatedData.pos;
  } else if (name === "Users") {
    return translatedData.users;
  } else if (name === "Payment Channels") {
    return translatedData.paymentChannels;
  } else if (name === "Subscription") {
    return translatedData.subscription;
  } else if (name === "View Invoices") {
    return translatedData.viewInvoices;
  } else if (name === "Only Last 5") {
    return translatedData.onlyLast5;
  } else if (name === "All Invoices") {
    return translatedData.allInvoices;
  } else if (name === "Change taxes in a sale") {
    return translatedData.changeTaxesInSale;
  } else if (name?.includes("quick product")) {
    return translatedData.showQuickProductInPos;
  } else if (name === "Perform refunds") {
    return translatedData.performRefunds;
  } else if (name === "Reprint and resend invoices") {
    return translatedData.reprintAndResendInvoices;
  } else if (name === "Manage items") {
    return translatedData.manageMenu;
  } else if (name === "Manage settings") {
    return translatedData.changeSettings;
  } else if (name === "Manage POS devices via email login") {
    return translatedData.managePosLoginViaEmailLogin;
  } else if (name === "Log Book") {
    return translatedData.logBook;
  } else {
    return name;
  }
};

export const handlePagesAccessAsPerRolePermissions = (backOfficeAccess, access) => {
  return backOfficeAccess && access[0]?.selected
    ? "/analytics/sales-summary"
    : backOfficeAccess && access[1]?.selected
    ? "/invoices"
    : backOfficeAccess && access[2]?.selected
    ? "/customers"
    : backOfficeAccess && access[3]?.selected && access[3]?.subItem[0]?.selected
    ? "/products"
    : backOfficeAccess && access[3]?.selected && access[3]?.subItem[1]?.selected
    ? "/categories"
    : backOfficeAccess && access[3]?.selected && access[3]?.subItem[2]?.selected
    ? "/discounts"
    : backOfficeAccess && access[4]?.selected
    ? "/information"
    : backOfficeAccess && access[3]?.selected && access[3]?.subItem[7]?.selected
    ? "/subscription"
    : backOfficeAccess && access[3]?.selected && access[3]?.subItem[7]?.selected
    ? "/subscription/new"
    : backOfficeAccess && access[3]?.selected && access[3]?.subItem[2]?.selected
    ? "/users"
    : backOfficeAccess
    ? "/user-settings"
    : backOfficeAccess && access[3]?.selected && access[3]?.subItem[2]?.selected
    ? "/users/add"
    : backOfficeAccess && access[0]?.selected
    ? "/sales-by-product"
    : backOfficeAccess && access[0]?.selected
    ? "/sales-by-category"
    : backOfficeAccess && access[0]?.selected
    ? "/sales-by-user"
    : backOfficeAccess && access[0]?.selected
    ? "/sales-by-time"
    : backOfficeAccess && access[0]?.selected
    ? "/sales-by-payment-channel"
    : backOfficeAccess && access[0]?.selected
    ? "/tax-report"
    : backOfficeAccess && access[0]?.selected
    ? "/discount-report"
    : "/error/access-denied";
};

export const isPageAccessAllowed = (path, backOfficeAccess, access, module) => {
  if (path === "/dashboard" && backOfficeAccess && access[0]?.selected) {
    return true;
  } else if (path === "/invoices" && backOfficeAccess && access[1]?.selected) {
    return true;
  } else if (path === "/customers" && backOfficeAccess && access[2]?.selected) {
    return true;
  } else if (path === "/products" && backOfficeAccess && access[3]?.selected && access[3]?.subItem[0]?.selected) {
    return true;
  } else if (path === "/categories" && backOfficeAccess && access[3]?.selected && access[3]?.subItem[1]?.selected) {
    return true;
  } else if (path === "/discounts" && backOfficeAccess && access[3]?.selected && access[3]?.subItem[2]?.selected) {
    return true;
  } else if (path === "/information" && backOfficeAccess && access[4]?.selected && access[4]?.subItem[0]?.selected) {
    return true;
  } else if (
    (path === "/subscription" || path === "/subscription/new" || path === "/subscription/add-payment-card") &&
    backOfficeAccess &&
    access[4]?.selected &&
    access[4]?.subItem[7]?.selected
  ) {
    return true;
  } else if ((path === "/users" || path === "/users/add") && backOfficeAccess && access[4]?.selected && access[4]?.subItem[2]?.selected) {
    return true;
  } else if (module === "analytics" && backOfficeAccess && access[0]?.selected) {
    return true;
  } else if (path === "/taxes" && backOfficeAccess && access[4]?.selected && access[4]?.subItem[5]?.selected) {
    return true;
  } else if (path === "/pos-devices" && backOfficeAccess && access[4]?.selected && access[4]?.subItem[3]?.selected) {
    return true;
  } else if (path === "/roles" && backOfficeAccess && access[4]?.selected && access[4]?.subItem[1]?.selected) {
    return true;
  } else if (path === "/stores" && backOfficeAccess && access[4]?.selected && access[4]?.subItem[4]?.selected) {
    return true;
  } else if (path === "/payment-channels" && backOfficeAccess && access[4]?.selected && access[4]?.subItem[6]?.selected) {
    return true;
  } else if (path === "/zatca" && backOfficeAccess && access[9]?.selected) {
    return true;
  } else if (path === "/loyalty") {
    return true;
  }
  return false;
};

export const handleDataPermissions = (user) => {
  let dataPermissions = {};
  if (user && user?.rolePayload) {
    dataPermissions["createData"] = user?.rolePayload?.backOfficePayload[5]?.selected;
    dataPermissions["editData"] = user?.rolePayload?.backOfficePayload[6]?.selected;
    dataPermissions["deleteData"] = user?.rolePayload?.backOfficePayload[7]?.selected;
  }
  return dataPermissions;
};

export const disabledSelectRowSetting = {
  mode: "checkbox",
  clickToSelect: false,
  hideSelectColumn: true,
  selectable: () => false,
};

export const applyMarginLeftToSideBar = () => {
  let path = window.location.pathname;

  if (
    path.includes("/sales-by-time") ||
    path.includes("/sales-summary") ||
    path.includes("/sales-by-user") ||
    path.includes("/subscription") ||
    path.includes("/discount-report")
  ) {
    return "100px";
  } else if (path.includes("/sales-by-product") || path.includes("/sales-by-category") || path.includes("/user-settings")) {
    return "120px";
  } else if (
    path.includes("/pos-devices") ||
    path.includes("/customer") ||
    path.includes("/products") ||
    path.includes("/discounts") ||
    path.includes("/categories")
  ) {
    return "70px";
  } else if (path.includes("/sales-by-payment-channel")) {
    return "210px";
  } else if (path.includes("/discounts") || path.includes("/invoices")) {
    return "50px";
  } else if (path.includes("/payment-channels")) {
    return "150px";
  } else return "30px";
};

export const translatePdfInvoiceStatus = (status, language) => {
  if (language === "ar") {
    if (status === "paid") {
      return "مدفوع";
    }
  }
  return status?.charAt(0)?.toUpperCase() + status?.slice(1);
};

export const generateLogsXML = (log) => {
  let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
  xml += `<AuditLogs exportedAt="${new Date().toISOString()}">\n`;
  xml += `  <Log id="${log?._id}">\n`;
  xml += `    <Message>${log?.logMessage}</Message>\n`;
  xml += `    <CreatedAt>${log?.createdAt}</CreatedAt>\n`;
  xml += `    <Actor>${log?.createdBy || ""}</Actor>\n`;
  xml += `    <InvoiceId>${log?.additionalInfo?.invoiceName || ""}</InvoiceId>\n`;
  xml += `    <PosId>${log?.additionalInfo?.moreDetails?.posId || log?.additionalInfo?.posId || ""}</PosId>\n`;
  xml += `    <StoreId>${log?.additionalInfo?.moreDetails?.storeId || log?.additionalInfo?.storeId || ""}</StoreId>\n`;
  xml += `    <Status>${log?.additionalInfo?.response || log?.additionalInfo?.moreDetails?.status}</Status>\n`;
  xml += `  </Log>\n`;
  xml += `</AuditLogs>`;
  return xml;
};

export const generateAllLogsXML = (logs) => {
  let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
  xml += `<AuditLogs exportedAt="${new Date().toISOString()}">\n`;

  logs.forEach((log) => {
    xml += `  <Log id="${log?._id}">\n`;
    xml += `    <Message>${log?.logMessage}</Message>\n`;
    xml += `    <CreatedAt>${log?.createdAt}</CreatedAt>\n`;
    xml += `    <Actor>${log?.createdBy || ""}</Actor>\n`;
    xml += `    <PosId>${log?.additionalInfo?.posId || ""}</PosId>\n`;
    xml += `    <StoreId>${log?.additionalInfo?.storeId || ""}</StoreId>\n`;
    xml += `    <Status>${log?.additionalInfo?.response || log?.additionalInfo?.moreDetails?.status}</Status>\n`;
    xml += `  </Log>\n`;
  });

  xml += `</AuditLogs>`;
  return xml;
};

export const generateAllInvoiceLogsXML = (logs) => {
  let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
  xml += `<AuditLogs exportedAt="${new Date().toISOString()}">\n`;

  logs.forEach((log) => {
    xml += `  <Log id="${log?._id}">\n`;
    xml += `    <Message>${log?.logMessage}</Message>\n`;
    xml += `    <CreatedAt>${log?.createdAt}</CreatedAt>\n`;
    xml += `    <Actor>${log?.createdBy || ""}</Actor>\n`;
    xml += `    <PosId>${
      log?.additionalInfo?.moreDetails?.posId ? log?.additionalInfo?.moreDetails?.posId : log?.additionalInfo?.posId ? log?.additionalInfo?.posId : ""
    }</PosId>\n`;
    xml += `    <StoreId>${
      log?.additionalInfo?.moreDetails?.storeId
        ? log?.additionalInfo?.moreDetails?.storeId
        : log?.additionalInfo?.storeId
        ? log?.additionalInfo?.storeId
        : ""
    }</StoreId>\n`;
    xml += `    <Status>${
      log?.additionalInfo?.moreDetails?.status === "paid" ? "Success" : log?.additionalInfo?.response || log?.additionalInfo?.moreDetails?.status
    }</Status>\n`;
    xml += `  </Log>\n`;
  });

  xml += `</AuditLogs>`;
  return xml;
};

export const generatePhase1QR = (invoiceData, storeData) => {
  try {
    // 1. Map your variables to ZATCA Tags
    const tags = [
      { id: 1, value: storeData?.name || storeData?.companyName || "" },
      { id: 2, value: storeData?.taxNumber || "" },
      { id: 3, value: new Date(invoiceData?.invoiceDate || Date.now()).toISOString() },
      { id: 4, value: (invoiceData?.totalaftertax || 0).toString() },
      { id: 5, value: (invoiceData?.taxTotal || 0).toString() },
    ];

    // 2. Encode to TLV
    const tlvParts = tags.map(({ id, value }) => {
      const valueBuffer = new TextEncoder().encode(value);
      const tagBuffer = new Uint8Array([id]);
      const lengthBuffer = new Uint8Array([valueBuffer.length]);

      const combined = new Uint8Array(tagBuffer.length + lengthBuffer.length + valueBuffer.length);
      combined.set(tagBuffer);
      combined.set(lengthBuffer, tagBuffer.length);
      combined.set(valueBuffer, tagBuffer.length + lengthBuffer.length);
      return combined;
    });

    // 3. Concatenate
    const totalLength = tlvParts.reduce((acc, part) => acc + part.length, 0);
    const finalBuffer = new Uint8Array(totalLength);
    let offset = 0;
    tlvParts.forEach((part) => {
      finalBuffer.set(part, offset);
      offset += part.length;
    });

    // 4. Binary to Base64 (Safe for Arabic/UTF-8)
    let binary = "";
    for (let i = 0; i < finalBuffer.byteLength; i++) {
      binary += String.fromCharCode(finalBuffer[i]);
    }
    return window.btoa(binary);
  } catch (error) {
    console.error("QR Generation Error:", error);
    return "";
  }
};

export const getTimezoneFromCountry = (countryName) => {
  const country = Object.values(ct.getAllCountries()).find((c) => c.name.toLowerCase() === countryName.toLowerCase());

  return country?.timezones?.[0] || "UTC";
};
